function Process() {
  const steps = [
    {
      title: "ヒアリング・要件定義",
      description:
        "お客様のビジネス課題やニーズを詳細にヒアリング。目的を明確化し、最適なソリューションの方向性を定めます。",
      duration: "1-2週間",
    },
    {
      title: "設計・提案",
      description:
        "要件に基づいて技術選定、システム設計、スケジュール、見積もりを含む詳細な提案書を作成します。",
      duration: "1-2週間",
    },
    {
      title: "開発・実装",
      description:
        "アジャイル手法で段階的に開発を進行。定期的な進捗共有と柔軟な仕様調整で品質を確保します。",
      duration: "4-12週間",
    },
    {
      title: "テスト・検証",
      description:
        "機能テスト、パフォーマンステスト、セキュリティチェックを実施。品質保証を徹底します。",
      duration: "1-2週間",
    },
    {
      title: "納品・運用開始",
      description:
        "スムーズな移行をサポート。操作マニュアルの提供や運用トレーニングも実施します。",
      duration: "1週間",
    },
    {
      title: "保守・改善",
      description:
        "運用開始後も継続的にサポート。定期的なメンテナンスと改善提案で長期的な成功を支援します。",
      duration: "継続",
    },
  ];

  return (
    <section
      id="process"
      className="relative overflow-hidden bg-red-50 px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="fade-in-section mb-12 text-center md:mb-20">
          <h2 className="mb-3 text-4xl font-semibold text-gray-900 md:mb-4 md:text-6xl">
            <span className="text-red-500">P</span>rocess
          </h2>
          <p className="text-gray-600">開発の流れ</p>
        </div>
        <div className="relative">
          <div className="absolute bottom-0 left-1/2 top-0 hidden w-0.5 bg-gradient-to-b from-gray-300 via-red-500 to-gray-300 lg:block"></div>
          <div className="space-y-12 md:space-y-16">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`fade-in-section flex items-center gap-8 ${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                }`}
                style={{ transitionDelay: `${index * 60}ms` }}
              >
                <div className="flex-1 rounded-xl border-2 border-gray-200 bg-white p-6 shadow-md transition-all duration-300 md:p-8">
                  <h3 className="mb-4 text-2xl font-semibold text-gray-900">
                    {step.title}
                  </h3>
                  <p className="mb-4 text-sm leading-relaxed text-gray-600">
                    {step.description}
                  </p>
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <i className="ri-time-line"></i>
                    <span>{step.duration}</span>
                  </div>
                </div>
                <div
                  className="hidden h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-500 font-bold text-white shadow-lg lg:flex"
                  style={{ zIndex: 2 }}
                >
                  {index + 1}
                </div>
                <div className="hidden flex-1 lg:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
